const dealSummary = {
  id: null,
  notes: null,
  statusId: null,
  firstName: null,
  lastName: null,
  emailAddress: null,
  existingClientId: null,
  clientName: null,
  invoiceFrequencyId: null,
  thirdPartyPortalId: null,
  corporateName: null,
  ein: null,
  dealAssignmentType: null,
  employeeTypeId: null,
  startAt: null,
  endAt: null,
  payFrequencyId: null,
  payRateTypeId: null,
  payRate: null,
  contractTypeId: null,
  lengthOfContract: null,
  conversionFee: null,
  billRateTypeId: null,
  billRate: null,
  jobTitle: null,
  permPlacementDate: null,
  permPlacementSalary: null,
  permPlacementNetFee: null,
  permPlacementInvoiceDate: null,
  permPlacementInvoiceDueDate: null,
  commissions: null,
  expenses: null,
  workedHoursAverage: null,
  overtimeThreshold: null,
  overtimeRate: null,
  timeSheetType: 2,
  clockIPAddress: null
}
export default () => Object.assign({}, dealSummary)
